import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TTvDashboardState } from './tv-dashboard.model';
import { TComponentNames } from '@monorepo/types';

export const selectTvDashboardStore = createFeatureSelector<TTvDashboardState>('TV_DASHBOARD');

export const getWebsocketConnectionStatus = createSelector(
  selectTvDashboardStore,
  (selectTvDashboardStore) => selectTvDashboardStore.connectionStatus,
);

export const getComponentDataByChannelId = <T extends TComponentNames>(componentName: T, channelId: string) =>
  createSelector(
    selectTvDashboardStore,
    (selectTvDashboardStore) => selectTvDashboardStore.messages[componentName][channelId],
  );
